import React, { Component } from "react";
import SelectBox from "../../components/common/SelectBox";
import string from "../../string";
import { Form, Modal, Input, DatePicker, Descriptions, Upload, Button, Checkbox } from "antd";
import { httpPut, httpUrl, httpPost, serverUrl } from "../../api/httpClient";
import {
  formatDateSecond,
  formatDate,
  startDateFormat,
  endDateFormat,
} from "../../util";
import locale from "antd/es/date-picker/locale/ko_KR";

const FormItem = Form.Item;
const Ditems = Descriptions.Item;
const RangePicker = DatePicker.RangePicker;

class NoticeRegist extends Component {
  constructor(props) {
    super(props)
    this.state = {
      push: true,
      main: true,
      categoryType: 'NOTE'
    }
  }
  onCreate = (e) => {
    let {form} = this.props;
    
    e.preventDefault();
    form.validateFields((err, values) => {
      if (!err) {
        values.title = {};
        values.content = {};
        global.languages.map((value, index)=>{
          values.title[value.code.toLowerCase()] = values['title'+value.code];
          values.content[value.code.toLowerCase()] = values['content'+value.code];
        });
        values.main = this.state.main ? 1 : 0;
        values.push = this.state.push ? 1 : 0;
        values.category = this.state.categoryType;
        console.log(JSON.stringify(values))
        httpPost(httpUrl.noticeCreate, [], values).then((res) => {
          if (res.data !== 0) {
            form.resetFields();
            this.props.onOk();
          } else {
            alert("알수없는 문제로 등록에 실패하였습니다..");
          }
        });
      }
    });
  }
  render() {
    const { visible, onCancel, form } = this.props;
    const { getFieldDecorator } = form;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 17 }
      }
    };
    return (
      <Modal
        visible={visible}
        title="공지 등록"
        okText="등록"
        cancelText="취소"
        onOk={this.onCreate}
        onCancel={onCancel}
        style={{ minWidth: "800px" }}>
        <div>
          <Form {...formItemLayout} onSubmit={this.onCreate}>
                <FormItem style={{float: 'left', width: 300}}>
                  <SelectBox
                    value={string.noticeSelect[this.state.categoryType]}
                    code={string.noticeSelectCode}
                    codeString={string.noticeSelect}
                    onChange={value => {
                      if (value !== this.state.categoryType)
                        this.setState({categoryType: value})
                    }}
                    style={{ width: "160px", marginRight: "10px" }}
                  />
                  </FormItem>
                <FormItem style={{float: 'right', width: 200}}>
                  <Checkbox 
                    style={{ marginLeft: "10px" }}
                    onChange={(e) => {
                      this.setState({main: e.target.checked});
                    }}
                    checked={this.state.main}
                    >
                    메인노출
                  </Checkbox>
                </FormItem>
                {/* <FormItem style={{float: 'right', width: 200}}>
                  <Checkbox 
                    style={{ marginLeft: "10px" }}
                    onChange={(e) => {
                      this.setState({push: e.target.checked});
                    }}
                    checked={this.state.push}
                    >
                    푸시발송
                  </Checkbox>
                </FormItem> */}
            <Descriptions
              bordered
              column={{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 2, xs: 2 }}>

              {global.languages.map((value, index)=>{
                return (
                <>
                  <Ditems label={"제목("+value.name+")"} span={2}>
                    <FormItem>
                    {getFieldDecorator("title"+value.code, { 
                      rules: [ { required: value.code=="Ko", message: "제목을 입력해 주세요" } ] ,
                    })(<Input/>)}
                    </FormItem>
                  </Ditems>
                  <Ditems label={"내용("+value.name+")"} span={2}>
                    <FormItem >
                    {getFieldDecorator("content"+value.code, { 
                      rules: [ { required: value.code=="Ko", message: "내용을 입력해 주세요" } ]  ,
                    })(<Input.TextArea/>)}
                      </FormItem>
                  </Ditems>
                </>
                )
              })}
              </Descriptions>
          </Form>
        </div>
      </Modal>
    );
  }
}
export default Form.create()(NoticeRegist)